import { Container } from '@mui/material';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';

import theme from '../../styles/theme';
import Header from './Header';

/**
 * Layout shell permanente común a todas las páginas protegidas.
 */
const Layout = (props) => {
  return (
    <>
      <Header />
      <Container
        maxWidth={false}
        disableGutters
        sx={{ pt: { xs: 14, sm: 14.5 }, backgroundColor: theme.palette.background.main, minHeight: '100vh' }}
      >
        {props.children || <Outlet />}
      </Container>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
